module.exports = __webpack_public_path__ + "DevashishTiwari-51bf7190.webp";